const mapStateToThis = ({ config }) => {
  return {
    copyrightYear: config.copyrightYear,
  };
};

const mapDispatchToThis = {};

@Inject('$ngRedux')
export class RwCopyrightController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-copyright/rw-copyright-controller.js